import React from 'react';
import { useTheme } from '../theme';
import logoDark from '../assets/brand/traq_logo_dark.png';
import logoLight from '../assets/brand/traq_logo_light.png';

const TraqLogo = ({ height = 40, className = '', style, alt = 'TRAQ' }) => {
  const { scheme } = useTheme();
  const src = scheme === 'dark' ? logoDark : logoLight;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        height,
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        ...style,
      }}
    />
  );
};

export default TraqLogo;
